import brandedSolid from './branded-solid';
import solidIcon from './solid-icon';

export default {
  brandedSolid,
  solidIcon,
};
